import { GridApiCommon, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { memo } from "react";
import { TbHeartHandshake } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import TimeCellEditor from "@/components/table/TimeCellEditor";
import { PlanPickupCell } from "@/pages/Plannn/components/table/PlanPickupColumn";

import { HotelClinicTaskResolved } from "../../types";
import { pickUpThenHotelComparator } from "../../utils/pickUpThenHotelComparator";
import ClinicArrivalTasksEditableColumn from "./ClinicArrivalTasksEditableColumn";

const MemoComponent = memo(
    ({
        value,
        row,
        field,
        api,
        editable,
    }: {
        api: GridApiCommon;
        field: string;
        row: HotelClinicTaskResolved;
        value: string;
        editable: boolean;
    }) => {
        return (
            <ClinicArrivalTasksEditableColumn
                renderHistoryComp={(val) => <PlanPickupCell value={val as string} />}
                api={api}
                field={field}
                id={row.id}
                editable={editable}
            >
                <PlanPickupCell value={value} />
            </ClinicArrivalTasksEditableColumn>
        );
    }
);

export function ClinicArrivalTaskPickupColumn({
    t,
    editable,
}: {
    t: TFunction;
    editable: boolean;
}): GridColDef<HotelClinicTaskResolved> {
    return {
        field: "pickUp",
        headerName: t("pickUp"),
        minWidth: 140,
        editable,
        renderHeader: (params) => <TableHeader Component={TbHeartHandshake} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.pickUp,
        sortComparator: pickUpThenHotelComparator,
        renderCell: (params: GridRenderCellParams<HotelClinicTaskResolved>) => (
            <MemoComponent
                editable={editable}
                api={params.api}
                row={params.row}
                field={params.field}
                value={params.value}
            />
        ),
        renderEditCell: (params) => (
            <div
                data-clinic-arrival-no-row-dnd
                className="h-full min-h-0 w-full select-text"
                onPointerDown={(e) => e.stopPropagation()}
            >
                <TimeCellEditor {...params} field="pickUp" />
            </div>
        ),
    };
}
